// @flow

export default {
  id: { "ui:widget": "hidden" },
  name: {
    "ui:autofocus": true,
  },
};
